import { useAppConfigContext } from '@/context/AppContext';

const useToast = () => {
  const { dispatch } = useAppConfigContext();
  const { triggerToast } = dispatch;

  const triggerError = (payload: any) => {
    triggerToast({
      severity: 'error',
      position: 'bottom',
      show: true,
      durationInms: 3000,
      showIcon: false,
      ...payload,
    });
  };

  const triggerDefault = (payload: any) => {
    triggerToast({
      severity: 'default',
      position: 'bottom',
      show: true,
      showIcon: false,
      // showCloseButton:true,
      durationInms: 3000,
      ...payload,
    });
  };

  const triggerSuccess = (payload: any) => {
    triggerToast({
      severity: 'success',
      position: 'bottom',
      show: true,
      showIcon: false,
      durationInms: 3000,
      ...payload,
    });
  };

  return { triggerDefault, triggerError, triggerSuccess };
};

export default useToast;
